<template>
    <div class="bonus-banner" v-if="bonusBannerVisible">
        <WheelBanner :is-coin="false" :text="bonusBannerTextShort" :link="bonusBannerLink"></WheelBanner>
        <div class="bonus-banner__close" @click="emit('closeBonusBanner')"></div>
    </div>
</template>

<script lang="ts" setup>
import WheelBanner from "@/wheel-of-fortune/wheel-page/components/win-popup/components/wheel-banner.vue";
import { useObtainableBonus } from "@/composables/use-obtainable-bonus";
import { computed } from "vue";

const emit = defineEmits(["closeBonusBanner"]);

const { obtainableBonusData, bonusBannerLink, bonusBannerTextShort } = useObtainableBonus();
const bonusBannerVisible = computed<boolean>(() => !!obtainableBonusData.value);
</script>
